import { TerminalShell } from "../components/TerminalShell";
import { Markdown } from "../components/Markdown";
import { getPage } from "../content/loader";

const ASCII = ` █████╗ ██████╗  ██████╗ █████╗ ███╗   ██╗███████╗    ██╗      █████╗ ██████╗ ███████╗
██╔══██╗██╔══██╗██╔════╝██╔══██╗████╗  ██║██╔════╝    ██║     ██╔══██╗██╔══██╗██╔════╝
███████║██████╔╝██║     ███████║██╔██╗ ██║█████╗      ██║     ███████║██████╔╝███████╗
██╔══██║██╔══██╗██║     ██╔══██║██║╚██╗██║██╔══╝      ██║     ██╔══██║██╔══██╗╚════██║
██║  ██║██║  ██║╚██████╗██║  ██║██║ ╚████║███████╗    ███████╗██║  ██║██████╔╝███████║
╚═╝  ╚═╝╚═╝  ╚═╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═══╝╚══════╝    ╚══════╝╚═╝  ╚═╝╚═════╝ ╚══════╝`;

export function Home() {
  const page = getPage("home");
  return (
    <TerminalShell chromeTitle="home">
      <section className="lh__section">
        <h1 className="lh__hero" aria-label="Arcane Labs">
          <pre className="lh__ascii" aria-hidden="true">
            {ASCII}
          </pre>
        </h1>
        {page?.greeting && <p className="lh__greeting">{page.greeting}</p>}
        <hr className="lh__rule" />
        <div className="prose">
          <Markdown source={page?.body ?? ""} variant="page" />
        </div>
      </section>
    </TerminalShell>
  );
}
